var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"centerTop"}},[_c('div',{staticClass:"lb-title"},[_vm._v("怀柔区就业基地分布图")]),_c('div',{style:({ height: _vm.height, width: _vm.width }),attrs:{"id":"mapc"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }